const DOCS_ROOT = "https://docs.loopscale.com";

export const DOCS = {
    root: DOCS_ROOT,
    borrowTutorial: `${DOCS_ROOT}/using-loopscale/borrow/overview`,
    lendTutorial: `${DOCS_ROOT}/using-loopscale/advanced-lend`,
    loopTutorial: `${DOCS_ROOT}/using-loopscale/loop`,
    lendVaultTutorial: `${DOCS_ROOT}/protocol-concepts/loopscale-vaults`,
    pointsTutorial: `${DOCS_ROOT}/using-loopscale/points`
};
